import {
  Grid,
  Flex,
  AspectRatio,
  Image,
  Button,
  BoxProps,
} from '@chakra-ui/react'
import useTranslation from 'next-translate/useTranslation'
import { fadeIn } from '@lib/motion'
import { useInViewMotion } from '@lib/hooks'
import { MotionBox, MotionText, Link } from '@ui'

interface ISsmFriendlyCardAdvantages extends BoxProps {
  isReverseOnMobile?: boolean
}

const SsmFriendlyCardAdvantages = ({
  isReverseOnMobile = false,
  ...rest
}: ISsmFriendlyCardAdvantages) => {
  const { t } = useTranslation('common')
  const { controls, ref } = useInViewMotion(true)

  return (
    <MotionBox
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={fadeIn.animationContainer}
    >
      <Grid
        as="section"
        gridTemplateColumns={{ base: '1fr', lg: '1fr 1fr' }}
        templateAreas={{
          base: isReverseOnMobile
            ? `'ssm-card-content' 'ssm-card-img'`
            : `'ssm-card-img' 'ssm-card-content'`,
          lg: `'ssm-card-content ssm-card-img '`,
        }}
        {...rest}
      >
        <AspectRatio ratio={1.85 / 1} gridArea="ssm-card-img">
          <Image
            loading="lazy"
            width="full"
            src="https://drupal.sakipsabancimuzesi.org/sites/default/files/styles/webp/public/2026-04/muzekart2026_2560x1196px_revize.jpg.webp"
            fallbackSrc="/img/placeholders/no-image-available-icon.jpeg"
            alt={t('ssmFriendlyCardAdvantages.title')}
          />
        </AspectRatio>
        <Flex
          flexDirection="column"
          alignItems="flex-start"
          px="padding.primary"
          py={{ base: 'padding.primary', lg: 'padding.primary3' }}
          gridArea="ssm-card-content"
        >
          <MotionText
            variants={fadeIn.up}
            color="red.primary"
            fontSize={{ base: 'xl', lg: '2xl' }}
            mb={{ base: 3, lg: 5 }}
          >
            {t('ssmFriendlyCardAdvantages.title')}
          </MotionText>
          <MotionText variants={fadeIn.up} fontWeight="light" mb={5}               fontSize={{ base: 'sm', lg: 'md' }}
          >
            {t('ssmFriendlyCardAdvantages.description')}
          </MotionText>
          <MotionBox variants={fadeIn.up}>
            <Button variant="link" as={Link} href="/membership" target="_blank"               fontSize={{ base: 'sm', lg: 'md' }}
            >
              {t('ssmFriendlyCardAdvantages.buttonLabel')}
            </Button>
          </MotionBox>
        </Flex>
      </Grid>
    </MotionBox>
  )
}

export default SsmFriendlyCardAdvantages
